if (!customElements.get('ts-enterprise-footer')) {
  customElements.define('ts-enterprise-footer', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const groups = [...this.querySelectorAll('.ts-ef__group')];
      const media = window.matchMedia('(max-width: 749px)');
      const collapses = this.dataset.collapse === 'true';
      const update = () => {
        const interactive = media.matches && collapses;
        groups.forEach(group => {
          group.open = !interactive;
          group.querySelector('summary').tabIndex = interactive ? 0 : -1;
        });
      };
      const onClick = event => {
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary) && !(media.matches && collapses)) event.preventDefault();
        if (event.target.closest('[data-ts-ef-top]')) {
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      };
      const onSubmit = event => {
        if (event.target.matches('[data-ts-ef-preview-form]')) {
          event.preventDefault();
          event.target.querySelector('[data-ts-ef-preview-message]').hidden = false;
        }
      };
      this.addEventListener('submit', onSubmit);
      this.querySelector('[data-ts-ef-top]')?.removeAttribute('hidden');
      update();
      media.addEventListener('change', update);
      this.addEventListener('click', onClick);
      this.cleanup = () => {
        media.removeEventListener('change', update);
        this.removeEventListener('click', onClick);
        this.removeEventListener('submit', onSubmit);
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
